import { Link, useNavigate } from "react-router-dom";
import { AppRouteURL, AppRouteURLwithChilds, DetailsRouteURL, TestSereisRouteURL } from "@Constants/app-route-url.constant";
import "./Das-header.scss";
import { useAppSelector, useAppDispatch } from "@Src/app/hooks";
import { ReactComponent as IabhyasLogo } from "@Src/assets/svg/iabhyas-logo.svg";
import LogoutSvg from "@Assets/svg/HeaderSvg/Logout.svg";
import ActiveLogoutSvg from "@Assets/svg/HeaderSvg/ActiveLogout.svg";
import DownArrow from "@Assets/svg/Home_svgs/DownArrow.svg";
import { clearUserData } from "@Src/app/reducers/auth/loginSlice";
import { clearCoursePreferences, setCoursePreferences } from "@Src/app/reducers/auth/coursePreferencesSlice";
import { toast } from "react-hot-toast";
import { useUserDisplayName } from "@Src/utils/userDisplayName";
import SvgIcon from "@Components/icons/SvgIcon";
import { Tooltip } from 'react-tooltip';
import { persistor } from "@Src/app/store";
import { useEffect, useRef, useState } from "react";
import { APIResponse, APIStatus } from "@Src/services/baseInterfaces";
import { getClassList, getCouresePreferences, UpdateCoursePrefernces } from "@Src/features/UserProfile/Services/UserProfile.sevice";

export const DashHeaderIndex = ({ toggleSidebar, isSidebarOpen }: { toggleSidebar?: () => void, isSidebarOpen?: boolean }) => {
  const navigation = useNavigate();
  const dispatch = useAppDispatch();
  const profileImageUrl = useAppSelector(state => state.login.profileImageUrl);
  const logout = async () => {
    dispatch(clearUserData());
    dispatch(clearCoursePreferences());
    try {
      await persistor.purge();
    } catch (error) {
      console.error("Persistor purge error:", error);
    }
    localStorage.removeItem('persist:root');
    localStorage.removeItem('redirectAfterSubscription');
    toast.success('You have loggged out successfully');
    window.location.replace(`${process.env.REACT_APP_MAIN_SITE_URL}?logout=true`);
  }

  const displayName = useUserDisplayName();
  const LastName = useAppSelector(state => state.login.Lastname)
  const coursePreferences = useAppSelector(state => state.coursePreferences);
  const targetExam = coursePreferences?.boardDetails?.[0]?.Name;
  const InstituteId = useAppSelector(state => state.login.InstituteId)
  const instituteLogoUrl = useAppSelector(state => state.login.Institutelogoimageurl)
  const language = useAppSelector(state => state.login.LanguageName);

  const targetClass = coursePreferences?.classDetails?.[0]?.Name;
  const languageId = useAppSelector(state => state.login.LanguageId);

  const [classList, setClassList] = useState<any[]>([]);
  const [visibleClasses, setVisibileClasses] = useState<boolean>(false);
  const classSelectorRef = useRef<HTMLDivElement>(null);




  const fetchClassList = async (boardId: number) => {
    try {
      const response: APIResponse = await getClassList({ boardId });
      if (response.ResponseType === APIStatus.SUCCESS && response.data) {
        setClassList(response.data);
        //    submitFilters.updateClasses?.(response.data);
        console.log("class list fetched successfully:", response.data);
      }
    } catch (error) {
      console.error('Failed to fetch class list:', error);
    }
  };

  const fetchCoursePreferences = async () => {
    try {
      const coursePreferencesResponse = await getCouresePreferences();
      if (coursePreferencesResponse?.ResponseType === APIStatus.SUCCESS && coursePreferencesResponse.data) {
        dispatch(setCoursePreferences(coursePreferencesResponse.data));
      }
    } catch (err) {
      console.error("Failed to fetch course preferences after registration", err);
    }
  }
  useEffect(() => {
    fetchClassList(coursePreferences?.boardDetails?.[0]?.Id);
  }, [coursePreferences])

  const handleClassUpdate = async (id: number) => {
    if (id !== coursePreferences.classDetails[0]?.Id) {


      try {
        const response = await UpdateCoursePrefernces({
          languageListId: languageId,
          classlistId: [id],
          boardListId: [coursePreferences.boardDetails[0]?.Id],
          subjectListId: coursePreferences.subjectDetails.map(({ Id }) => Id),
          educationInterestListId: coursePreferences.educationInterestDetails.map(({ Id }) => Id),
        });
        if (response.ResponseType === APIStatus.SUCCESS && response.data) {
          fetchCoursePreferences();
          toast.success("Class updated successfully")
        }

      } catch (error) {
        toast.error("Failed to update the class")
      }
    }
    setVisibileClasses(false);
  }

  useEffect(() => {
    fetchCoursePreferences();
  }, [])


  useEffect(() => {
    const handleOutsideClick = (event: PointerEvent) => {
      if (
        visibleClasses &&
        classSelectorRef.current &&
        !classSelectorRef.current.contains(event.target as Node)
      ) {
        setVisibileClasses(false);
      }
    };

    document.addEventListener("pointerdown", handleOutsideClick);
    return () => document.removeEventListener("pointerdown", handleOutsideClick);
  }, [visibleClasses]);
  return (
    <>
      <div className="dash-header-sect py-2 px-4 sticky top-0 tw-flex tw-items-center tw-z-[9999]">
        <div className="tw-flex tw-items-center tw-gap-4">
          {toggleSidebar && (
            <button
              className="hamburger-btn tw-p-2 tw-text-gray-600 hover:tw-bg-gray-100 tw-rounded-lg"
              onClick={toggleSidebar}
              aria-label={isSidebarOpen ? "Close Sidebar" : "Open Sidebar"}
            >
              <svg className="tw-w-6 tw-h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {isSidebarOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          )}
          <div className="header-logo">
            <Link to="/">
              {InstituteId && instituteLogoUrl ? (
                <img src={instituteLogoUrl} alt="Institute Logo" className="iabhyas-logo" style={{ height: window.innerWidth < 1024 ? "auto" : "100px", width: window.innerWidth < 1024 ? "auto" : "100px" }} />
              ) : (
                <IabhyasLogo className="iabhyas-logo" />
              )}
            </Link>
          </div>
        </div>

        <div className="tw-flex tw-items-center ">
          {/* <span className="notif-bell-span">
                        <img src={NotificationBellSvg} alt="notification-svg-img" />
                    </span> */}
          <div className="user-loged-in">
            <div className="user-profile-container">
              <div className="user-profile-header-main tw-flex tw-justify-end">
                <div data-tooltip-id="profile-tooltip" data-tooltip-content="My Profile" className="user-name tw-overflow-hidden tw-cursor-pointer" onClick={() => { navigation(AppRouteURL.USERPROFILE + AppRouteURL.MYPROFILE) }}>
                  <span>
                    {profileImageUrl ? (
                      <span><img src={profileImageUrl} alt="Profile" className="twt-w-full twt-h-full tw-object-cover tw-rounded-full" /></span>
                    ) : (
                      <span><img src={require("@Assets/img/profile-picture.png")} alt="" className="twt-w-full twt-h-full tw-object-cover" /></span>
                    )}
                  </span>
                </div>
                <Tooltip id="profile-tooltip" place="bottom" style={{ fontSize: '12px', padding: '4px 8px' }} />
                <ul className="login-drop-down-prof-dash">
                  <li className="dropdown-ui-1  text-sm px-2 py-2">
                    <a href="javascript:void(0)" style={{ textTransform: 'none' }}>
                      {displayName}
                      <span className="down-arrow-svg ml-1">
                        <SvgIcon name="downArrow" />
                      </span>
                    </a>
                    <ul className="dropdown-ui-container dropdown-menu-right w-auto mw-auto">
                      <li className="user-dropdown-li text-sm px-2 py-2" onClick={() => navigation((AppRouteURL.DASHBOARD + AppRouteURL.DASHBOARD_HOME),{state:{reload:true}})}>
                        <a href="javascript:void(0)">Dashboard</a>
                      </li>
                      <li className="user-dropdown-li text-sm px-2 py-2" onClick={() => navigation(TestSereisRouteURL.DIAGNOSTIC_TEST_SERIES)}>
                        <a href="javascript:void(0)">Readiness Check</a>
                      </li>
                      <li className="user-dropdown-li text-sm px-2 py-2" onClick={() => navigation(TestSereisRouteURL.TEST_SERIES)}>
                        <a href="javascript:void(0)">Practice Test</a>
                      </li>
                      <li className="user-dropdown-li text-sm px-2 py-2" onClick={() => navigation(TestSereisRouteURL.PREVIOUS_YEAR_MOCK_TEST_SERIES)}>
                        <a href="javascript:void(0)">Previous Year Test</a>
                      </li>
                      <li className="user-dropdown-li text-sm px-2 py-2" onClick={() => navigation(TestSereisRouteURL.FULL_MOCK_TEST_SERIES)}>
                        <a href="javascript:void(0)">Mock Test</a>
                      </li>
                      <li className="user-dropdown-li text-sm px-2 py-2" onClick={() => navigation(AppRouteURL.USERPROFILE + AppRouteURL.COURSEPREFERD)}>
                        <a href="javascript:void(0)">Study Profile</a>
                      </li>
                      <li className="user-dropdown-li text-sm px-2 py-2" onClick={() => navigation(AppRouteURL.DASHBOARD + AppRouteURL.TEST_ACTIVITY)}>
                        <a href="javascript:void(0)">My Test</a>
                      </li>
                      {/* <li className="user-dropdown-li text-sm px-2 py-2" onClick={() => navigation(AppRouteURL.VIDEO_BRANCHING)}>
                        <a href="javascript:void(0)">Concept Videos</a>
                      </li> */}
                      <li className="user-dropdown-li text-sm px-2 py-2" onClick={() => navigation(AppRouteURL.DASHBOARD + AppRouteURL.MIND_MAP)}>
                        <a href="javascript:void(0)">Revision Hub</a>
                      </li>
                      {/* <li className="user-dropdown-li text-sm px-2 py-2" onClick={() => navigation(AppRouteURL.DASHBOARD + AppRouteURL.TEST_ACTIVITY)}>
                        <a href="javascript:void(0)">Test Activity</a>
                      </li> */}


                      {!InstituteId && <li className="user-dropdown-li  text-sm px-2 py-2">
                        <a href="javascript:void(0)" onClick={() => navigation(AppRouteURL.SUBSCRIPTION)}>My Subscription</a></li>}

                      <li className="user-dropdown-li  text-sm px-2 py-2">
                        <a href="javascript:void(0)" onClick={logout} >
                          Logout
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
              {targetExam && targetClass && (
                // <div className="user-exam-badge-row">
                //   <span className="exam-badge">Target Exam: {targetExam}</span>
                // </div>
                <div className="tw-flex tw-justify-center tw-items-center">
                  <div className="user-exam-badge-row tw-cursor-pointer" onClick={() => { navigation(AppRouteURL.USERPROFILE + AppRouteURL.COURSEPREFERD) }}>
                    <span className="tw-text-xs tw-font-semibold tw-text-purple-500 tw-flex tw-justify-center tw-items-center"><span className="tw-mr-1"><SvgIcon size={16}name="coursePreferences" /></span>{targetExam} | {language} |</span>
                  </div>
                  <div ref={classSelectorRef} className='tw-text-center tw-ml-1'>

                    <ul >
                      <li className="" style={{ padding: "0px", position: "relative" }}><span className="tw-cursor-pointer tw-text-xs  tw-font-semibold tw-text-purple-500 " onClick={(e) => {
                        setVisibileClasses((prev) => !prev);
                      }}>Class: {targetClass} <span className="down-arrow-svg tw-mt-1  tw-cursor-pointer">
                          <SvgIcon size={10} name="downArrow" />
                        </span></span>
                        <ul className="dropdown-ui-container dropdown-menu-right w-auto mw-auto" style={{ minWidth: "100px", visibility: 'visible', display: visibleClasses ? 'block' : 'none', opacity: visibleClasses ? 'unset' : '0', zIndex: "0" }}>
                          {
                            classList.map((cls) => {
                              return (
                                <li className="user-dropdown-li tw-text-sm tw-px-3 tw-py-2 tw-text-start tw-cursor-pointer" onClick={() => handleClassUpdate(cls.Id)}>
                                  <p>
                                    {cls.Name}
                                  </p>
                                </li>
                              )
                            })

                          }



                        </ul >
                      </li>
                    </ul>
                  </div>
                </div>
              )}

              {/* {
                targetClass && 
              } */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}